<script lang="ts">
  import Notification from './Notification.svelte';

  let notifications = [];
  let components: Notification[] = [];
  let id = 0;

  export function add(title: string, description: string, type: string = 'info') {
    const newNotification = { id, title, description, type };
    notifications = [newNotification, ...notifications];
    if (type !== 'error') {
      (_id => setTimeout(() => {
        let index = notifications.findIndex(n => n.id === _id);
        if (components[index]) { // it might have been closed manually
          components[index].hide().then(() => handleRemove(index));
        }
      }, 10e3))(id);
    }
    id++;
  }

  const handleRemove = (index: numbre) => {
		notifications = [
			...notifications.slice(0, index),
			...notifications.slice(index + 1, notifications.length)
		];
	};
	
	// handle element removal by filtering null
	$: components = components.filter(el => el);
</script>

<div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
  <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
    {#each notifications as notification, index (notification.id) }
      <Notification bind:this={components[index]}
                    removeFn={ () => handleRemove(index) }
                    title={notification.title}
                    description={notification.description}
                    type={notification.type} />
    {/each}
  </div>
</div>
